
import Stack from '@mui/material/Stack';
import { DialogContent } from '@mui/material';
import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import NewTimePicker from './NewTimePicker';
import { SCHEDULE_OPTIONS } from '../utils/structures';

export default function ScheduleSelector(props) {

    const [scheduleType, setScheduleType] = useState(SCHEDULE_OPTIONS.closed)
    const [open, setOpen] = useState(false)
    const [schedules, setSchedules] = useState(
        {
            active: true,
            openAllDay: false,
            time: [{ start: '', end: '' }],
        }
    )

    useEffect(() => {
        setSchedules(props.day)
        setScheduleType(props.day.openAllDay ? SCHEDULE_OPTIONS.openAllDay :
            !props.day.active ? SCHEDULE_OPTIONS.closed : SCHEDULE_OPTIONS.customSchedule)
    }, [props.day])

    useEffect(() => {
        setSchedules(prev => {
            let aux = { ...prev }
            aux.openAllDay = scheduleType === SCHEDULE_OPTIONS.openAllDay
            aux.active = scheduleType !== SCHEDULE_OPTIONS.closed
            aux.time = scheduleType === SCHEDULE_OPTIONS.closed ? [{ start: '0000', end: '0000' }] : aux.time
            return aux
        })
    }, [scheduleType])

    const addSchedule = () => {
        let aux = { ...schedules }
        aux.time = schedules.time.concat({ start: '', end: '' })
        setSchedules(aux)
    }

    const removeSchedule = index => {
        let aux = { ...schedules }
        aux.time.splice(index, 1)
        setSchedules(aux)

        if (aux.time.length === 0) {
            setScheduleType(SCHEDULE_OPTIONS.closed)
        }
    }

    const updateSchedule = (index, value, isStart) => {
        let aux = { ...schedules }
        if (isStart) {
            aux.time[index].start = value
        } else {
            aux.time[index].end = value
        }
        setSchedules(aux)
    }

    const onSave = () => {

        // unificar horarios solapados
        let newSchedule = { ...schedules }
        if (schedules.time.length > 1) {

            if (schedules.time[0].start < schedules.time[1].start) {
                // [0] -> inicial
                if (schedules.time[1].start < schedules.time[0].end) {
                    newSchedule.time = [{ start: schedules.time[0].start, end: schedules.time[1].end }]

                } else {
                    // los ordeno de menor a mayor
                    if (newSchedule.time[1].start < newSchedule.time[0].start) {
                        const aux = newSchedule.time[0]
                        newSchedule.time[0] = newSchedule.time[1]
                        newSchedule.time[1] = aux
                    }
                }

            } else {
                if (schedules.time[1].end > schedules.time[0].start) {
                    newSchedule.time = [{ start: schedules.time[0].start, end: schedules.time[1].end }]

                } else {
                    // los ordeno de menor a mayor
                    if (newSchedule.time[1].start < newSchedule.time[0].start) {
                        const aux = newSchedule.time[0]
                        newSchedule.time[0] = newSchedule.time[1]
                        newSchedule.time[1] = aux
                    }
                }
            }
        }

        setSchedules(newSchedule)
        setOpen(false)
        props.setDaySchedule(newSchedule)
    }

    return (
        <>
            <IconButton size='large' onClick={() => setOpen(true)}>
                <EditOutlinedIcon />
            </IconButton>

            <Dialog
                onClose={() => setOpen(false)}
                open={open}
                fullWidth={true}
                maxWidth="sm"
            >
                <DialogTitle>Seleccionar horarios</DialogTitle>

                <DialogContent>
                    <Stack spacing={1}>
                        <Typography variant='h6'>{props.day.day}</Typography>

                        <FormControl>
                            <FormLabel>Tipo de horario</FormLabel>
                            <RadioGroup
                                defaultValue={SCHEDULE_OPTIONS.closed}
                                value={scheduleType}
                                onChange={e => setScheduleType(e.target.value)}
                            >
                                <FormControlLabel value={SCHEDULE_OPTIONS.closed} control={<Radio />} label="Cerrado" />
                                <FormControlLabel value={SCHEDULE_OPTIONS.openAllDay} control={<Radio />} label="Abierto 24 horas" />
                                <FormControlLabel value={SCHEDULE_OPTIONS.customSchedule} control={<Radio />} label="Indicar horario" />
                            </RadioGroup>
                        </FormControl>

                        {scheduleType !== SCHEDULE_OPTIONS.customSchedule ? null :
                            <>
                                <Stack>
                                    {schedules.time.map((schedule, index) => {
                                        return (
                                            <Stack direction='row' justifyContent='space-evenly' alignItems='center' key={index}>
                                                <NewTimePicker
                                                    prevTime={schedule}
                                                    setTime={(value, isStart) => updateSchedule(index, value, isStart)}
                                                />

                                                <IconButton onClick={() => removeSchedule(index)}>
                                                    <CloseIcon />
                                                </IconButton>
                                            </Stack>
                                        )
                                    })}
                                </Stack>

                                {schedules.time.length > 1 ? null :
                                    <Button onClick={() => addSchedule()} variant='outlined' >
                                        Agregar horario
                                    </Button>}
                            </>}

                    </Stack>

                    <Divider sx={{ m: 1 }} />

                    <Stack direction='row' justifyContent='flex-end' spacing={2}>
                        <Button variant='outlined' color='error' onClick={() => setOpen(false)}>
                            Cancelar
                        </Button>
                        <Button variant='outlined' onClick={() => onSave()}>
                            Guardar
                        </Button>
                    </Stack>
                </DialogContent>
            </Dialog >
        </>
    )
}